import React from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import ToastMessage from '../../components/ToastMessage';

const getText = (defaultMessage: string, id?: string) => {
  let text: string | JSX.Element = defaultMessage;
  if (id) {
    text = <FormattedMessage id={id} defaultMessage={defaultMessage} />;
  }
  return text;
};

export const successToast = (defaultMessage: string, id?: string) => (
  toast.success(<ToastMessage variant="success" text={getText(defaultMessage, id)} />)
);

export const infoToast = (defaultMessage: string, id?: string) => (
  toast.info(<ToastMessage variant="info" text={getText(defaultMessage, id)} />)
);

export const errorToast = (defaultMessage: string, id?: string) => (
  toast.error(<ToastMessage variant="error" text={getText(defaultMessage, id)} />)
);
